import { render } from "./ModalProcessKulioner.vue?vue&type=template&id=f48c9b24&scoped=true&ts=true"
import script from "./ModalProcessKulioner.vue?vue&type=script&lang=ts"
export * from "./ModalProcessKulioner.vue?vue&type=script&lang=ts"

import "./ModalProcessKulioner.vue?vue&type=style&index=0&id=f48c9b24&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f48c9b24"]])

export default __exports__